import requestShare from '@common/client/src/requestShare'

import LOGO from './logo'
import { resolveAPP, rejectAPP } from './type'

/**
 * 包装成promise的随手记分享
 * @param {*} title - 配置分享出去的标题
 * @param {*} content - 配置分享出去的文本
 * @param {*} url - 配置分享出去的url
 */
const helper = (title: string, content: string, url: string, image?: string): Promise<resolveAPP | rejectAPP> => {
  return new Promise((resolve, reject) => {
    requestShare(
      {
        title, // 分享标题
        content, // 分享内容
        url, // 分享url
        img: image || LOGO
      },
      async({ type, result }: { type: string; result: string }) => {
        // 分享回调函数, result为分享结果，取值为success（分享成功），cancel（取消分享），error（分享失败），type为分享类型，取值为qq,qzone,weixin,pyq,sina_weibo,link,message
        console.log('[ssj share res]', type, result)
        if (result === 'success') {
          resolve(<resolveAPP>type)
        } else if (result === 'error') {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject([result, type])
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject([result, type])
        }
      }
    )
  })
}

export default helper
